import EditIconComponent from '@scandipwa/scandipwa/src/component/EditIcon';

import {
    MyAccountAddressTable as SourceMyAccountAddressTable
} from 'SourceComponent/MyAccountAddressTable/MyAccountAddressTable.component';

import DeleteIconComponent from '../DeleteIcon';

import './MyAccountAddressTable.style';

/** @namespace Bodypwa/Component/MyAccountAddressTable/Component */
export class MyAccountAddressTableComponent extends SourceMyAccountAddressTable {
    renderActions() {
        const {
            onEditClick,
            onDeleteClick,
            showActions,
            address: { default_billing, default_shipping }
        } = this.props;

        const isDeleteAllowed = default_shipping || default_billing;

        if (!showActions) {
            return null;
        }

        return (
            <>
                <button
                  block="Button"
                  className="Edit"
                  onClick={ onEditClick }
                  mods={ { isHollow: true, isWithoutBorder: true } }
                >
                    <EditIconComponent />
                    { __('Edit') }
                </button>
                { !isDeleteAllowed ? (
                    <button
                      block="Button"
                      className="Delete"
                      mods={ { isHollow: true, isWithoutBorder: true } }
                      onClick={ onDeleteClick }
                      disabled={ isDeleteAllowed }
                      title={ __('Delete this address') }
                    >
                        <DeleteIconComponent />
                        { __('Delete') }
                    </button>
                ) : null }
            </>
        );
    }
}

export default MyAccountAddressTableComponent;
